export default (route: string, count: number): string => {
  return route.split('/').reverse().slice(count).reverse().join('/')
}
